import mapActions from './mapActions';

export default mapActions('operation_list', {
    fetchAll_url: data => `/api/operation_records/list/${data.year}/${data.month}`
});